import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Redirect } from "react-router";
import { Route, Switch } from "react-router-dom";
import ReportEditContainer from "../../Containers/ReportEditContainer";
import ReportRunId from "./ReportRunId";
import ReportDashboard from "./ReportDashboard";
import ReportCreateRoutes from "./Create/ReportCreateRoutes";
import ReportSourceHelpContainer from "./ReportSourceHelpContainer";
import { getDefaultRedirectBaseRoute, ID_VARIABLE, getPreBaseRoute, getPreBasePath, } from "../../../../components";
export const getReportBasePath = () => "/app/report";
export const getReportCreatePath = () => getReportBasePath() + "/create";
export const getReportCreateSourcePath = () => getReportBasePath() + "/create/source";
const getReportEditPath = () => getReportBasePath() + "/edit";
const getReportRunPath = () => getReportBasePath() + "/run";
const getReportDashboardPath = () => getReportBasePath() + "/dashboard";
const getReportSourceHelpPath = () => getReportBasePath() + "/help/source";
export const reportSourceCreatePath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        getReportCreateSourcePath() +
        ((params === null || params === void 0 ? void 0 : params.id) ? "/" + (params === null || params === void 0 ? void 0 : params.id) : ""));
};
export const reportRunPath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        getReportRunPath() +
        "/" +
        params.id);
};
export const reportHelpSourcePath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        getReportSourceHelpPath() +
        "/" +
        params.id);
};
export const reportDashboardPath = (params) => {
    return getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getReportDashboardPath();
};
export const reportEditPath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        getReportEditPath() +
        "/" +
        params.id);
};
export const getReportBaseRoute = () => getPreBaseRoute() + getReportBasePath();
export const getReportDashboardRoute = () => getPreBaseRoute() + getReportDashboardPath();
export const premadeReportPath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        "/controller/report/" +
        params.reportInternalName +
        "Report");
};
const ReportRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { component: ReportDashboard, path: getReportDashboardRoute() }), _jsx(Route, { component: ReportCreateRoutes, path: getPreBaseRoute() + getReportCreatePath() }), _jsx(Route, { component: ReportSourceHelpContainer, path: getPreBaseRoute() + getReportSourceHelpPath() + "/:sourceId" }), _jsx(Route, { component: ReportEditContainer, path: getPreBaseRoute() + getReportEditPath() + ID_VARIABLE() }), _jsx(Route, { component: ReportRunId, path: getPreBaseRoute() + getReportRunPath() + ID_VARIABLE() }), _jsx(Route, { component: () => (_jsx(Redirect, { to: getDefaultRedirectBaseRoute() + getReportDashboardPath() })), path: getReportBaseRoute() })] }));
};
export default ReportRoutes;
